import Phaser from "phaser";
import { CST } from "../CST";
import $ from "jquery";
import buttonBehaviours from "../helpers/button-behaviours";
import { hideTextFields, showTextFields } from "../helpers/text-fields";

export default class ResetPassword extends Phaser.Scene {
  constructor() {
    super(CST.SCENES.RESETPASSWORD);
  }

  preload() {
    this.load.image('bg-reset-password', 'assets/bg-reset-password.png');
    this.load.image('btn-reset-password', 'assets/btn-reset-password.png');
    this.load.image('back_btn', 'assets/english/go-backwards.png');
    this.load.image('error-code', 'assets/english/error/error-code.png');
    this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
    this.load.image('error-generic', 'assets/english/error/error-generic.png');
    this.load.image('error-passwords-not-match', 'assets/english/error/error-passwords-not-match.png');
    this.load.image('message-reset-password', 'assets/english/error/message-reset-password.png');
    this.load.image('message-success', 'assets/english/error/message-success.png');
    this.load.html('html-verification-code', 'html/verification-code.html');
    this.load.html('html-password', 'html/password.html');
    this.load.html('html-password-confirmation', 'html/password-confirmation.html');
  }

  create() {
    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-reset-password"
    );

    this.verificationCode = this.add
      .dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 - 130)
      .createFromCache("html-verification-code");
    this.verificationCode =
      this.verificationCode.getChildByName("verificationCode");

    this.password = this.add
      .dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2)
      .createFromCache("html-password");
    this.password = this.password.getChildByName("password");

    this.passwordConfirmation = this.add
      .dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 + 130)
      .createFromCache("html-password-confirmation");
    this.passwordConfirmation = this.passwordConfirmation.getChildByName(
      "passwordConfirmation"
    );

    this.btnResetPassword = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 240,
        "btn-reset-password"
      )
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnResetPassword, () => {
          this.resetPassword();
        })
      );

    this.btnBack = this.add
      .image(90, this.cameras.main.height / 2 + 410, "back_btn")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnBack, () => {
          this.scene.start(CST.SCENES.SENDEMAIL);
        })
      )
      .setScale(1.5);
  }

  resetPassword() {
    let self = this;

    $.ajax({
      async: false,
      type: "post",
      url: "website/reset-password.php",
      data: {
        verificationCode: this.verificationCode.value,
        verificationCode2: localStorage.getItem("verificationCode"),
        email: localStorage.getItem("email"),
        password: this.password.value,
        passwordConfirmation: this.passwordConfirmation.value,
      },
      dataType: "JSON",
      success(response) {
        if (response[0] === 400) {
          hideTextFields([
            self.verificationCode,
            self.password,
            self.passwordConfirmation,
          ]);
          buttonBehaviours.disableInteraction([
            self.btnResetPassword,
            self.btnBack,
          ]);

          const error = self.add.image(
            self.cameras.main.width / 2,
            self.cameras.main.height / 2 - 175,
            response[1]
          );

          setTimeout(() => {
            showTextFields([
              self.verificationCode,
              self.password,
              self.passwordConfirmation,
            ]);
            buttonBehaviours.enableInteraction([
              self.btnResetPassword,
              self.btnBack,
            ]);
            error.destroy();
          }, 2000);
        } else {
          hideTextFields([
            self.verificationCode,
            self.password,
            self.passwordConfirmation,
          ]);
          buttonBehaviours.disableInteraction([
            self.btnResetPassword,
            self.btnBack,
          ]);

          self.add.image(
            self.cameras.main.width / 2,
            self.cameras.main.height / 2 - 175,
            response[1]
          );

          setTimeout(() => {
            localStorage.clear();
            self.scene.start(CST.SCENES.LOGIN);
          }, 2000);
        }
      },
      error(error) {
        console.log(error);
      },
    }).responseJSON;
  }
}
